const favEventsId = [];

export { favEventsId };
